function getUserPageHeaderProps(userProfile) {
  return userProfile ? {
    email: userProfile.email,
    firstName: userProfile.first_name,
    lastName: userProfile.last_name,
    pictureUrl: userProfile.pictureUrl
  } : undefined;
}
export default getUserPageHeaderProps;